import type { ReactNode, CSSProperties } from 'react';

export interface AtomicBlockWrapperProps {
  children: ReactNode;
  ariaLabel?: string;
  style?: CSSProperties;
}

export function AtomicBlockWrapper({ children, ariaLabel, style }: AtomicBlockWrapperProps) {
  return (
    <div aria-label={ariaLabel} data-testid="atomic-block-wrapper" style={{ breakInside: 'avoid', pageBreakInside: 'avoid', ...style }}>
      {children}
    </div>
  );
}
